module.exports = __webpack_public_path__ + "img/244-a824c4.png";